<script setup lang="ts">
import { useUserInfoStore } from '@/stores/modules/user'

const userStore = useUserInfoStore()
</script>
<template>
  <div class="logo">
    <div class="logo-icon">🔥</div>
    <span v-if="!userStore.collapse" class="logo-text">创美威智能监控</span>
  </div>
</template>
<style scoped lang="scss">
.logo {
  @apply flex items-center px-6 h-16 flex-shrink-0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.logo-icon {
  @apply flex-shrink-0 flex items-center justify-center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  font-size: 20px;
  margin-right: 12px;
}
.logo-text {
  @apply text-white text-nowrap;
  font-size: 18px;
  font-weight: 600;
}
</style>
